<template>
    <div class="Information">
        <div class="row">
            <div class="col col-md-4">
                <h4>Basic Info</h4>
                <p>
                    <span class="bold">Church Name: </span>
                    <StringEditor v-bind:old-value="ChurchRecordData.Church.Name"
                                  v-bind:record-id="ChurchRecordData.Church.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Church Name"
                                  property-name="Name"
                                  update-method="ChurchEngagement.Churches.UpdateChurch"
                                  v-bind:required="true" />
                </p>
                <p>
                    <span class="bold">Territory: </span>
                    <SelectEditor v-bind:old-value="ChurchRecordData.Church.Region"
                                  v-bind:old-value-text="ChurchRecordData.Church.Region"
                                  v-bind:record-id="ChurchRecordData.Church.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Territory"
                                  property-name="Territory"
                                  update-method="ChurchEngagement.Churches.UpdateChurch"
                                  required="true"
                                  v-bind:options="RegionOptions" />
                </p>
                <p>
                    <span class="bold">Involved in Foster: </span>
                    <SelectEditor v-bind:old-value="ChurchRecordData.Church.IsInvolvedWithFoster"
                                  v-bind:old-value-text="ChurchRecordData.Church.IsInvolvedWithFoster ? 'Yes' : 'No'"
                                  v-bind:record-id="ChurchRecordData.Church.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Involved with Foster?"
                                  property-name="IsInvolvedWithFoster"
                                  update-method="ChurchEngagement.Churches.UpdateChurch"
                                  required="true"
                                  v-bind:options="TrueFalseOptions" />
                </p>
                <p>
                    <span class="bold">Involved in Safe Families: </span>
                    <SelectEditor v-bind:old-value="ChurchRecordData.Church.IsInvolvedWithSafeFamilies"
                                  v-bind:old-value-text="ChurchRecordData.Church.IsInvolvedWithSafeFamilies ? 'Yes' : 'No'"
                                  v-bind:record-id="ChurchRecordData.Church.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Involved with Safe Families?"
                                  property-name="IsInvolvedWithSafeFamilies"
                                  update-method="ChurchEngagement.Churches.UpdateChurch"
                                  required="true"
                                  v-bind:options="TrueFalseOptions" />
                </p>
                <p>
                    <span class="bold">Involved in Community Involvement: </span>
                    <SelectEditor v-bind:old-value="ChurchRecordData.Church.IsInvolvedWithCommunityInvolvement"
                                  v-bind:old-value-text="ChurchRecordData.Church.IsInvolvedWithCommunityInvolvement ? 'Yes' : 'No'"
                                  v-bind:record-id="ChurchRecordData.Church.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Involved with Community Involvement?"
                                  property-name="IsInvolvedWithCommunityInvolvement"
                                  update-method="ChurchEngagement.Churches.UpdateChurch"
                                  required="true"
                                  v-bind:options="TrueFalseOptions" />
                </p>
            </div>
            <div class="col col-md-4">
                <h4>Physical Address</h4>
                <AddressEditor v-bind:old-value="ChurchRecordData.Church.AddressPhysical"
                               v-bind:record-id="ChurchRecordData.Church.AddressPhysical.Id"
                               v-bind:edit-mode="EditMode"
                               data-label="Physical Address"
                               update-method="Core/Address/Update"
                               required="true" />
            </div>
            <div class="col col-md-4">
                <h4>Mailing Address</h4>
                <AddressEditor v-bind:old-value="ChurchRecordData.Church.AddressMailing"
                               v-bind:record-id="ChurchRecordData.Church.AddressMailing.Id"
                               v-bind:edit-mode="EditMode"
                               data-label="Mailing Address"
                               update-method="Core/Address/Update"
                               required="true" />
            </div>
        </div>
        <div class="row">
            <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                <font-awesome-icon :icon="['fa', 'edit']" />
                <span v-if="EditMode"> Edit Mode: ON</span>
                <span v-else> Edit Mode: OFF</span>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import StringEditor from '../../../Core/ItemEditors/StringEditor';
    import DateEditor from '../../../Core/ItemEditors/DateEditor';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor';
    import AddressEditor from '../../../Core/ItemEditors/AddressEditor';
    export default {
        props: [
            'ChurchRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            StringEditor,
            DateEditor,
            SelectEditor,
            AddressEditor
        },
        mounted() {

        },
        computed: {
            RegionOptions: function () {
                return this.$store.state.Options.ChurchRegions;
            },
            TrueFalseOptions: function () {
                return this.$store.state.Options.TrueFalseOptions;
            }
        }
    }
</script>

<style scoped>
</style>